import type {MultiEditValue} from 'feature/editMultiThesaurus/types';
import type {ThesaurusId} from 'services/thesaurus/types';

export const sortedEncodeMultiThesaurusValue = (
  value: MultiEditValue,
): string => {
  const ids = [...Object.keys(value)].sort() as ThesaurusId[];
  return ids.map(id => [...(value[id] ?? [])].sort().join(';')).join(';');
};
